import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import {
  Checkbox,
  Button,
  Input,
  Form,
  Icon,
  Message
} from "semantic-ui-react";
import TextBlock from "../text/TextBlock";
import TextParagraph from "../../../../../components/ui/TextParagraph";

/**
 * MultipleChoiceBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Content block for a multiple choice quiz question
 *
 * @param {*} props
 */
class MultipleChoiceBlock extends Component {
  state = {
    currentAnswer: -1,

    isDirty: false,
    isCorrect: false
  };

  checkSolution = () => {
    const correct = this.props.block.answer === this.state.currentAnswer;

    this.setState({
      isDirty: true,
      isCorrect: correct
    });
  };

  addAnswer = () => {
    const block = { ...this.props.block };
    const answers = [...block.answers, ""];

    block.answers = answers;
    this.props.onChange(block);
  };

  removeAnswerAtIndex = i => {
    const block = { ...this.props.block };
    const answers = [...block.answers];

    answers.splice(i, 1);
    block.answers = answers;

    if (block.answer >= i) {
      block.answer -= 1;
    }

    this.props.onChange(block);
  };

  changeAnswerTo = i => {
    const block = { ...this.props.block };
    block.answer = i;

    this.props.onChange(block);
  };

  changeAnswerAtIndex = (i, value) => {
    const block = { ...this.props.block };
    const answers = [...block.answers];

    answers[i] = value;
    block.answers = answers;

    this.props.onChange(block);
  };

  render() {
    return this.props.isReadOnlyMode ? (
      <div className="ed-multiple-choice">
        <Form className="ed-multi-form">
          <TextParagraph content={this.props.block.question} />
          <div className="ed-quiz-multiple">
            {this.props.block.answers.map((answer, i) => (
              <div className="ed-quiz-option" key={i}>
                <Checkbox
                  checked={this.state.currentAnswer === i}
                  onClick={() => {
                    this.setState({ currentAnswer: i });
                  }}
                  className={
                    this.state.isDirty && this.props.block.answer === i
                      ? "correct"
                      : null
                  }
                  label={answer}
                />
              </div>
            ))}
          </div>
          {!this.state.isCorrect ? (
            <Button color="blue" compact onClick={() => this.checkSolution()}>
              <FormattedMessage
                id="manuscript.blocks.quiz.checkAnswer"
                description="Button to check the answer"
              />
            </Button>
          ) : null}
        </Form>
        {this.state.isDirty ? (
          <Message
            warning={!this.state.isCorrect}
            positive={this.state.isCorrect}
          >
            <Icon name={this.state.isCorrect ? "checkmark" : "warning"} />
            {this.state.isCorrect ? (
              <FormattedMessage
                id="manuscript.blocks.quiz.correctAnswer"
                description="Info text displayed when the correct answer was entered"
              />
            ) : (
              <FormattedMessage
                id="manuscript.blocks.quiz.wrongAnswer"
                description="Info text displayed when the correct answer was entered"
                values={{
                  correctAnswer: this.props.block.answers[
                    this.props.block.answer
                  ]
                }}
              />
            )}
          </Message>
        ) : null}
      </div>
    ) : (
      <div>
        <TextBlock
          {...this.props}
          dataKey={"question"}
          placeholder={"manuscript.blocks.multiplechoice.placeholder"}
        />
        <div className="ed-quiz-multiple">
          {this.props.block.answers.map((answer, i) => (
            <div className="ed-quiz-option" key={i}>
              <Form>
                <Checkbox
                  checked={this.props.block.answer === i}
                  onClick={() => {
                    this.changeAnswerTo(i);
                  }}
                />
                <Input
                  value={answer}
                  onChange={(_, { value }) => {
                    this.changeAnswerAtIndex(i, value);
                  }}
                  placeholder={this.props.intl.formatMessage({
                    id: "manuscript.blocks.quiz.answer"
                  })}
                />
                <Button
                  compact
                  icon="remove"
                  onClick={() => this.removeAnswerAtIndex(i)}
                />
              </Form>
            </div>
          ))}
        </div>
        <div className="ed-block-controls">
          <Button onClick={() => this.addAnswer()} basic>
            <Icon name="add" />
            <FormattedMessage
              id="manuscript.blocks.multiplechoice.addAnswer"
              description="Button action to add another answer choice"
            />
          </Button>
        </div>
      </div>
    );
  }
}

MultipleChoiceBlock.propTypes = {
  isReadOnlyMode: PropTypes.bool.isRequired,
  /**
   * block: {text}
   * Contains the content block information
   */
  block: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.string).isRequired,
    answer: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired
  }).isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired,

  /**
   * intl: intlShape
   * Localization helper provided by react-intl
   */
  intl: intlShape.isRequired
};

export default injectIntl(MultipleChoiceBlock);



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/quiz/MultipleChoiceBlock.js